// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"SplitModal_modalContent__2DCEL","footer":"SplitModal_footer__xKHpk"};